export const messages = {
  en: {
    adminAccount: {
      search: {
        title: 'Search Conditions',
        acctType: 'Please select account type',
        ownerName: 'Please enter account name',
        idCard: 'Please enter ID number',
        link: 'Please enter contact information'
      },
      list: {
        title: 'Owner Account'
      },
      table: {
        acctId: 'Account ID',
        acctName: 'Account Name',
        idCard: 'ID Number',
        link: 'Phone Number',
        acctTypeName: 'Account Type',
        amount: 'Account Amount',
        roomName: 'Deduction Room',
        createTime: 'Create Time',
        noRoom: 'None'
      },
      btn: {
        detail: 'Account Details'
      },
      allCommunities: 'All Communities'
    }
  },
  zh: {
    adminAccount: {
      search: {
        title: '查询条件',
        acctType: '请选择账户类型',
        ownerName: '请输入账户名称',
        idCard: '请输入身份证号',
        link: '请输入联系方式'
      },
      list: {
        title: '业主账户'
      },
      table: {
        acctId: '账户编号',
        acctName: '账户名称',
        idCard: '身份证号',
        link: '手机号',
        acctTypeName: '账户类型',
        amount: '账户金额',
        roomName: '扣款房号',
        createTime: '创建时间',
        noRoom: '无'
      },
      btn: {
        detail: '账户明细'
      },
allCommunities: '全部小区'
    }
  },
  'zh-TW': {
    adminAccount: {
      search: {
        title: '查詢條件',
        acctType: '請選擇賬戶類型',
        ownerName: '請輸入賬戶名稱',
        idCard: '請輸入身份證號',
        link: '請輸入聯繫方式'
      },
      list: {
        title: '業主賬戶'
      },
      table: {
        acctId: '賬戶編號',
        acctName: '賬戶名稱',
        idCard: '身份證號',
        link: '手機號',
        acctTypeName: '賬戶類型',
        amount: '賬戶金額',
        roomName: '扣款房號',
        createTime: '創建時間',
        noRoom: '無'
      },
      btn: {
        detail: '賬戶明細'
      },
      allCommunities: '全部小區'
    }
  }
}